const routes = [
  {
    path: '/',
    component: () => import('../pages/Home'),
    meta: {
      title: 'Home',
      layout: 'main'
    }
  },
  {
    path: '/Home',
    component: () => import('../pages/Home'),
    meta: {
      title: 'Home',
      layout: 'main'
    }
  },
  {
    path: '/Beauty',
    component: () => import('../pages/Beauty'),
    meta: {
      title: 'Beauty',
      layout: 'main'
    }
  },
  {
    path: '/Energetisch',
    component: () => import('../pages/Energetisch'),
    meta: {
      title: 'Energetisch',
      layout: 'main'
    }
  },
  {
    path: '/YonKa',
    component: () => import('../pages/YonKa'),
    meta: {
      title: 'YonKa',
      layout: 'main'
    }
  },
  {
    path: '/Coaching',
    component: () => import('../pages/Coaching'),
    meta: {
      title: 'Coaching',
      layout: 'main'
    }
  },
  {
    path: '/Arrangement',
    component: () => import('../pages/Arrangement'),
    meta: {
      title: 'Arrangementen',
      layout: 'main'
    }
  },
  {
    path: '/Contact',
    component: () => import('../pages/Contact'),
    meta: {
      title: 'Contact',
      layout: 'main'
    }
  }
];

export { routes };
